<template>
  <div class="abnormalcommontStyle">
    <div class="iconBox abnormalPromptIcon"><Image :src="iconUrl" /></div>
    <div v-if="firstTitle" class="firstTitle">
      {{ firstTitle }}
    </div>
    <div v-if="SecondTitle" class="SecondTitle">
      {{ SecondTitle }}
    </div>
    <div v-if="buttonText" class="button">
      <van-button icon="replay" @click="buttonClickFc" type="primary">{{ buttonText }}</van-button>
    </div>
  </div>
</template>

<script>
import { Image } from 'vant';

export default {
  name: 'abnormalPrompt',
  props: {
    iconUrl: {
      type: String,
    },
    firstTitle: {
      type: String,
      default: () => '',
    },
    SecondTitle: {
      type: String,
      default: () => '',
    },
    buttonText: {
      type: String,
      default: () => '',
    },
    buttonClick: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Image,
  },
  setup(props, { emit }) {
    const buttonClickFc = () => {
      emit('buttonClick');
    };

    return {
      buttonClickFc,
    };
  },
};
</script>

<style lang="scss" scoped>
.iconBox {
  padding-top: 150px;
  text-align: center;
}
.icon {
  width: 100px;
  height: 100px;
  color: red;
}
.firstTitle {
  text-align: center;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.SecondTitle {
  font-weight: 400;
  color: #999999;
  font-size: 14px;
  text-align: center;
}
.button {
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #969799;
  a {
    color: #1890ff;
  }
}
.abnormalcommontStyle {
  // height: calc(100vh);
  min-height: 360px;
  :deep(.abnormalPromptIcon .van-image) {
    width: 161px;
    height: 160px;
  }
  :deep(.abnormalPromptIcon .van-button) {
    width: 112px;
    height: 45px;
    background: #ffffff !important;
    border-radius: 24px !important;
    border: 1px solid $primary-color !important;
  }
  :deep(.button .van-button--normal) {
    width: 112px;
    height: 45px;
    background: #ffffff !important;
    border-radius: 24px !important;
    border: 1px solid $primary-color !important;
    color: $primary-color;
    margin-top: 16px;
  }
}
</style>
